import { Button } from '@material-ui/core';
import React from 'react';
import { IconWithTooltip } from '../icons/IconWithTooltip';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';

export function ClearAllButton({ clearAllFilter, title }) {

    return (
        <IconWithTooltip title={`${title ? title : "Filterek törlése"}`} >
            <Button className="material-action-icon-button" onClick={clearAllFilter}>
                <DeleteOutlinedIcon className="material-action-icon" />
            </Button>
        </IconWithTooltip>
    )
}